export const ActivityType = {
  EMAIL: 'Email',
  CALL: 'Call',
  MEETING: 'Meeting',
};
